import { useSelector } from 'react-redux';
import EmailTemplateView from './email-template/EmailTemplateView';
import ShareDetailsForm from './email-template/ShareDetailsForm';
import { useEffect, useState } from 'react';
import {  API_TYPES, BACK_ORDER_APPLICATION, DOCUMENT_CATEGORY, STATUS_SUB_STATUS, TEMPLATE_TYPE_BROKER } from "@src/config/constant";
import { fetchLeadData, updateLeadDetailsInStore } from '@src/store/slices/insurance';
import { useDispatch } from "react-redux";
import { useLanguage } from '@src/context/LanguageContext';
import SendBackToAgentPopup from './SendBackToAgentPopup';

const SentToInsuranceBroker = (props: any) => {

    const [templateData, setTemplateData] = useState("");
    const [validDocuments, setValidDocuments] = useState<any>({firstSubmit: [], disbursal: []});

    const insuranceState = useSelector((state:any)=> state.insurance);
    const dispatch: any = useDispatch();
    const [apiTriggered, setApiTriggered] = useState(0);
    const {translations} = useLanguage();

    // Initilise the exits check varibales
    const [emailTemplateExists, setEmailTemplateExists] = useState(false);
    const [whatsappTemplateExists, setWhatsappTemplateExists] = useState(false);
    const [selectedBranchId, setSelectedBranchId] = useState<number>(0);
    const [sendBackToAgentPopup, setSendBackToAgentPopup] = useState(false);
    const hasBackOrderApplicationDocs = insuranceState?.leadDetail?.images?.some((image: any) => +image?.doc_id === BACK_ORDER_APPLICATION && image?.path);
    const showSendBackButton = +insuranceState?.leadDetail?.status_id === STATUS_SUB_STATUS['status']['application']
        && +insuranceState?.leadDetail?.sub_status_id === STATUS_SUB_STATUS['subStatus']['application_created']
        && !hasBackOrderApplicationDocs
    const isBackOrderApplication = +insuranceState?.leadDetail?.status_id === STATUS_SUB_STATUS['status']['application']
        && +insuranceState?.leadDetail?.sub_status_id === STATUS_SUB_STATUS['subStatus']['back_order_application']
    useEffect(()=>{
        //CHECK VALID DOCUMENTS WHO HAVE IMAGES UPLOADED
        if(insuranceState.leadDetail && insuranceState.leadDetail.images && insuranceState.leadDetail.images.length) {
            for(let elm of insuranceState.leadDetail.images){
                if(elm.doc_type_id === DOCUMENT_CATEGORY['firstSubmit']['doc_type_id']){
                    validDocuments['firstSubmit'] = [...validDocuments['firstSubmit'], elm.doc_id];
                }else if(elm.doc_type_id === DOCUMENT_CATEGORY['disbursal']['doc_type_id']){
                    validDocuments['disbursal'] = [...validDocuments['disbursal'], elm.doc_id];
                }
            }
            setValidDocuments({...validDocuments});
        }
        // eslint-disable-next-line
    }, [insuranceState.leadDetail]);

    useEffect(() => {
        if(Object.keys(insuranceState.leadDetail).length && !apiTriggered){
            setApiTriggered((prev)=> prev+1)
            fetchLeadData({ "lead_id": props.leadHashId, "type": TEMPLATE_TYPE_BROKER, apiType: API_TYPES['templateData'] }).then((res: any) => {
                if (res && res.data && Object.keys(res.data).length) {
                    let templateInfo = res.data.templateData
                    let response = res.data
                    delete response.templateInfo
                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, sharedTemplateData: templateInfo, ...response }))
                    
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insuranceState.leadDetail])

    return (
        <div className="image-form-outer">

            <EmailTemplateView templateType="broker" insuranceDetails={props.insuranceDetails} setTemplateData={(data: string)=> setTemplateData(data)} setEmailTemplateExists={setEmailTemplateExists} setWhatsappTemplateExists={setWhatsappTemplateExists} selectedBranchId={selectedBranchId}/>

            <ShareDetailsForm templateType="broker" getDocumentsIds={validDocuments} insuranceDetails={props.insuranceDetails} templateData={templateData} title={translations.Insurance?.['Send to Insurance Broker'] || translations.commonMsg?.loading} activeTab={props.activeTab} emailTemplateExists={emailTemplateExists} whatsappTemplateExists={whatsappTemplateExists} setSelectedBranchId={setSelectedBranchId} showSendBackButton={showSendBackButton} onSendBackToAgent={() => setSendBackToAgentPopup(true)} disableSaveAndNext={isBackOrderApplication}/>

            <SendBackToAgentPopup show={sendBackToAgentPopup} handleClose={() => setSendBackToAgentPopup(false)} getDetails={props.getDetails} />

        </div>
    );
};

export default SentToInsuranceBroker;
